import React from 'react';
import { CART_LINK, trackAddToCart } from '../lib/constants';
interface CTAButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
}
export function CTAButton({
  children,
  variant = 'primary',
  className = ''
}: CTAButtonProps) {
  const base = 'inline-flex items-center justify-center px-8 py-5 md:py-6 rounded-sm text-lg font-semibold tracking-wide transition-all duration-300 hover:-translate-y-0.5';
  const styles = variant === 'primary' ? 'bg-ink text-base hover:bg-ink/90 shadow-md hover:shadow-lg' : 'bg-primary text-base hover:bg-primary/90 shadow-md hover:shadow-lg';
  return <a href={CART_LINK} onClick={() => trackAddToCart()} className={`${base} ${styles} ${className}`} data-id="element-47">
      {children}
    </a>;
}